<div [ngClass]="{'auth-main': !isAuthenticated, 'model-reset': isAuthenticated, 'd-flex': true, 'flex-column': true, 'h-100': true}">
  <div class="p-3 d-flex flex-column align-items-center justify-content-center h-100">
    <form [formGroup]="dataForm" (ngSubmit)="reset()">
      <div class="login-content">
        <div class="header">
          <h4 class="mb-0"> @if(type == "changePassword") { Change Password } @else { Reset Password ? }
          </h4>
          <p class="py-3 mb-0 fs-14">
            @if(type == "changePassword") { Enter your current password to verify your identity, then create and confirm your new password. }
            @else { Enter the temporary password associated with your account and create a new password. }
          </p>
        </div>
        <div class="input-filed mt-2 resetdata">
          <div class="d-flex flex-column mb-2">
            <label class="mb-1 fs-14">@if(type == "changePassword") { Current Password } @else { Temporary Password }</label>
            <input class="form-control" type="password" formControlName="currentPassword" />
            @if (formControls['currentPassword'].touched && formControls['currentPassword'].invalid) {
            <div>
              @if (formControls['currentPassword'].errors?.['required']) {
              <small class="text-danger">Password is required.</small>
              }
            </div>
            }
          </div>
          <div class="d-flex flex-column mb-2">
            <label class="mb-1 fs-14">New Password</label>
            <input class="form-control" type="password" formControlName="newPassword" />
            @if (formControls['newPassword'].touched && formControls['newPassword'].invalid) {
            <div>
              @if (formControls['newPassword'].errors?.['required']) {
              <small class="text-danger">Password is required.</small>
              }
            </div>
            }
          </div>
          <div class="d-flex flex-column">
            <label class="mb-1 fs-14">Confirm Password</label>
            <input class="form-control" type="password" formControlName="confirmPassword" />
            @if (formControls['confirmPassword'].touched && formControls['confirmPassword'].invalid) {
            <div>
              @if (formControls['confirmPassword'].errors?.['required']) {
              <small class="text-danger">Confirm Password is required.</small>
              }
            </div>
            }
            <div>
              @if (formControls['confirmPassword'].touched &&
              formControls['confirmPassword'].errors?.['passwordMismatch']) {
              <small class="text-danger"> Passwords do not match.</small>}
            </div>
          </div>
        </div>
        @if(type == "changePassword")
        {
          <div class="submit-btn">
            <button type="submit" class="w-100">Change Password</button>
          </div>
        }
        @else
        {
          <div class="submit-btn mt-3">
            <button type="submit" class="w-100">Reset</button>
            <p class="text-center fs-14">Already have an account?
              <a routerLink="/auth">Sign In</a>
            </p>
          </div>
        }
      </div>
    </form>
  </div>
  @if(type !== "changePassword") {
    <div class="Copyright text-center">
      <p class="fs-14">Copyright © 2020-2025 Syfrox Company. All rights reserved.</p>
    </div>
  }
</div>
